const globalConfig = {
  // rootUrl_sit : 'http://192.168.2.14:8080',
  rootUrl_sit: 'https://beta.khsdb.com:444', //服务器地址
  domainName_sit: 'beta-jiaoyuju.khsdb.com',
  rootUrl_beta: 'https://beta.khsdb.com:444', //beta服务器地址
  domainName_beta: 'beta-jiaoyuju.khsdb.com',
  rootUrl_uat: 'https://api.khsdb.com', //生产服务器地址

  rootUrl_bureau_dev:'http://192.168.2.47:8000',// 教育局开发服务器
  rootUrl_bureau_beta:'https://beta-bureau-api.khsdb.com',// 教育局测试服务器
  rootUrl_bureau:'https://bureau-api.khsdb.com',// 教育局生产服务器

  domainName_uat: location.host,
  rootUrl: '', //服务器地址
  rootBureauUrl: '', //教育局服务器地址
  type: '', //处于什么平台
  fileUrl: 'https://static.khsdb.com/', //文件服务器地址
  appSecret: 'migoapi*^624123p(*&hashfwr65i',
  appId: '45671323458',
  pageSize: 10,
  domainName : null,
}

// globalConfig.rootUrl = globalConfig.rootUrl_sit
// globalConfig.type = 'sit'

// 测试环境
if (location.host.indexOf('localhost') != -1) {
  globalConfig.rootUrl = globalConfig.rootUrl_sit
  // globalConfig.rootBureauUrl = globalConfig.rootUrl_bureau_dev
  globalConfig.rootBureauUrl = globalConfig.rootUrl_bureau_beta
  globalConfig.type = 'sit'
  globalConfig.domainName = globalConfig.domainName_sit
  // console.log(location.hostname,globalConfig.domainName_sit,'localhost里面的内容')
}
//beta正式环境
else if (location.host.indexOf('beta') != -1) {
  globalConfig.rootUrl = globalConfig.rootUrl_beta
  globalConfig.rootBureauUrl = globalConfig.rootUrl_bureau_beta
  globalConfig.type = 'beta'
  globalConfig.domainName = location.hostname
  // console.log(location.hostname,globalConfig.domainName_sit,'localhost里面的内容')
}
//正式环境
else {
  globalConfig.rootUrl = globalConfig.rootUrl_uat
  globalConfig.rootBureauUrl = globalConfig.rootUrl_bureau
  globalConfig.type = 'uat'
  globalConfig.domainName = globalConfig.domainName_uat
}

export default globalConfig
